export default function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/translate/maxTranslate.js
// module id = 419
// module chunks = 0